import { render, staticRenderFns } from "./ProfileLoadModal.vue?vue&type=template&id=35a6cd9d"
import script from "./ProfileLoadModal.vue?vue&type=script&lang=js"
export * from "./ProfileLoadModal.vue?vue&type=script&lang=js"
import style0 from "./ProfileLoadModal.vue?vue&type=style&index=0&id=35a6cd9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports